var notes = {}

function saveNote(drug, note) {
	notes[drug] = note
}

function getNote(drug) {
	return notes[drug] || ""
}

function purgeNote(drug) {
	notes[drug] = ""
}

function importNotes(noteMap) {
	notes = noteMap
}

function getAllNotes() {
	return notes
}

export const notesService = {
	saveNote: saveNote,
	getNote: getNote,
	purgeNote,
	importNotes: importNotes,
	getAllNotes
}
